import React from 'react';

function Hero() {
  return (
    <div className="row">
      <div className="col-12">
        <br />
      </div>
      <div className="col-xl-4 col-lg-3 col-md-3 col-sm-3 text-center">
        <br />
      </div>
      <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 text-center">
        <img src={process.env.PUBLIC_URL + '/assets/logos/whiteLogoTransparent.png'} className="img-fluid ineffable-logo wow fadeInDown" style={{ backgroundColor: '#2a6c88' }} alt="Logo" />
        <p className="text-white mt-2 wow fadeIn" data-wow-delay="0.6s">
          Fundado con <i className="fas fa-heart"></i> en Colombia
        </p>
      </div>
      <div className="col-12 mt-2 text-center">
        <div className="container container-fluid">
          <h1 className="montserrat wow fadeInDown text-white">"Si puedes soñarlo, podemos hacerlo."</h1>
        </div>
      </div>
      <div className="col-12 mt-2 wow fadeIn">
        <hr />
      </div>
    </div>
  );
}

export default Hero;
